import { render } from "./ApprovalConfirmationModal.vue?vue&type=template&id=63b7eb8a&scoped=true"
import script from "./ApprovalConfirmationModal.vue?vue&type=script&lang=js"
export * from "./ApprovalConfirmationModal.vue?vue&type=script&lang=js"

import "./ApprovalConfirmationModal.vue?vue&type=style&index=0&id=63b7eb8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b7eb8a"]])

export default __exports__